(function () {
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .factory('DetailLevelFilter', DetailLevelFilterClass);

  function DetailLevelFilterClass(BaseFilterType, FiltersHelper, ReportFormat) {

    function DetailLevelFilter(filterData, stateParams) {
      if (!(this instanceof DetailLevelFilter)) return new DetailLevelFilter(filterData, stateParams);

      BaseFilterType.call(this, filterData, stateParams);
    }

    DetailLevelFilter.prototype = _.create(BaseFilterType.prototype, {
      formatFilterValues: FiltersHelper.formatFlatFilter,
      selectedParams: function (stateParams) {
        return getSelectedParams(stateParams);
      },
      isFilterSelected: function (params) {
        return [FiltersHelper.equalsDefaultFn(params)];
      }
    });

    function getSelectedParams(stateParams) {
      return stateParams.detailLevel || ReportFormat.Daily;
    }

    return DetailLevelFilter;

  }

})();